export default __webpack_public_path__ + "static/media/bell.0c69d92c.svg";